import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {currentUserStore} from '../../../../../api/user';

export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, program} = contexts;

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:program_updated.title.actor')
       * t('notifications:program_updated.title.you')
       * t('notifications:program_rejected.title.actor')
       * t('notifications:program_rejected.title.you')
       * t('notifications:program_resigned.title.actor')
       * t('notifications:program_resigned.title.you')
       * t('notifications:program_signed.title.actor')
       * t('notifications:program_signed.title.you')
       */
      i18n.t(
        `notifications:${event.type}.title.${
          actor?._id !== currentUserStore.user?._id ? 'actor' : 'you'
        }`,
        {
          actorName:
            actor?._id !== currentUserStore.user?._id
              ? actor?.name
              : i18n.t('shared:label.you'),
          programTitle: program?.title,
        },
      ),
  };
};
